import * as React from 'react'
import { Navigate, useLocation } from 'react-router-dom'

import * as Messages from '../../components/ui/messages/messages'
import { Container, Row, Col, Tab, Nav } from 'react-bootstrap'
import BillySettingsCard from '../../components/accountSettings/billySettings'
import GradeSettings from '../../components/accountSettings/gradeSettings'
import StaffSettings from '../../components/accountSettings/staffSettings'

import './accountSettings.css'
import FailedSyncCard from '../../components/accountSettings/failedSyncCard'
import { AppContext } from '../../App'
import * as I from '../../utilities/me'
import { Loading } from '../../components/ui/Loading/Loading'

const AccountSettings = () => {
	const { appState } = React.useContext(AppContext)

	const [messages, updateMessages] = Messages.useMessageReducer([])
	const location = useLocation()

	if (!appState.permission.roleID) {
		return (
			<Container fluid className="settings container pt-3">
				<Loading show />
			</Container>
		)
	}

	if (!I.haveAtLeast('director', appState.permission.roleID)) {
		return <Navigate to="/" />
	}

	return (
		<Container fluid className="settings-container pt-3">
			<Tab.Container defaultActiveKey={location.hash ? location.hash.slice(1) : 'general'} mountOnEnter>
				<Row>
					<Col sm={3}>
						<h3>Account Settings</h3>
						<Nav variant="pills" className="flex-column">
							<Nav.Item>
								<Nav.Link eventKey="general" href="#general">
									General Settings
								</Nav.Link>
							</Nav.Item>
							<Nav.Item>
								<Nav.Link eventKey="staff" href="#staff">
									Staff Settings
								</Nav.Link>
							</Nav.Item>
							<Nav.Item>
								<Nav.Link eventKey="grade" href="#grade">
									Grade Settings
								</Nav.Link>
							</Nav.Item>
							<Nav.Item>
								<Nav.Link eventKey="sync" href="#sync">
									Failed XPM Sync Items
								</Nav.Link>
							</Nav.Item>
						</Nav>
					</Col>
					<Col sm={9}>
						<Tab.Content>
							<Tab.Pane eventKey="general">
								<Row>
									<Col>
										<BillySettingsCard updateMessages={updateMessages} />
									</Col>
								</Row>
							</Tab.Pane>
							<Tab.Pane eventKey="staff">
								<StaffSettings updateMessages={updateMessages} />
							</Tab.Pane>
							<Tab.Pane eventKey="grade">
								<GradeSettings updateMessages={updateMessages} />
							</Tab.Pane>
							<Tab.Pane eventKey="sync">
								<FailedSyncCard />
							</Tab.Pane>
						</Tab.Content>
					</Col>
				</Row>
			</Tab.Container>

			<Messages.Messages messages={messages} updateMessage={updateMessages} />
		</Container>
	)
}

export default AccountSettings
